/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import {
  ADDRESS_FRAGMENT,
  BUNDLE_ORDER_ITEM_DETAILS_FRAGMENT,
  GIFT_CARD_DETAILS_FRAGMENT,
  ORDER_ITEM_DETAILS_FRAGMENT,
  PRICE_DETAILS_FRAGMENT,
  PRODUCT_DETAILS_FRAGMENT,
  ORDER_SUMMARY_FRAGMENT,
  RETURNS_FRAGMENT,
  ORDER_ITEM_FRAGMENT,
  GIFT_WRAPPING_FRAGMENT,
  GIFT_MESSAGE_FRAGMENT,
  APPLIED_GIFT_CARDS_FRAGMENT,
} from '@/order/api/fragments';

export const GUEST_ORDER_FRAGMENT = /* GraphQL */ `
  fragment GUEST_ORDER_FRAGMENT on CustomerOrder {
    printed_card_included
    gift_receipt_included
    gift_wrapping {
      ...GIFT_WRAPPING_FRAGMENT
    }
    gift_message {
      ...GIFT_MESSAGE_FRAGMENT
    }
    applied_gift_cards {
      ...APPLIED_GIFT_CARDS_FRAGMENT
    }
    items_eligible_for_return {
      ...ORDER_ITEM_DETAILS_FRAGMENT
    }
    email
    id
    number
    order_date
    order_status_change_date
    status
    token
    carrier
    shipping_method
    available_actions
    is_virtual
    returns {
      ...RETURNS_FRAGMENT
    }
    payment_methods {
      name
      type
    }
    applied_coupons {
      code
    }
    shipments {
      id
      number
      tracking {
        title
        number
        carrier
      }
      comments {
        message
        timestamp
      }
      items {
        __typename
        id
        product_sku
        product_name
        order_item {
          ...ORDER_ITEM_DETAILS_FRAGMENT
          ... on GiftCardOrderItem {
            ...GIFT_CARD_DETAILS_FRAGMENT
            product {
              ...PRODUCT_DETAILS_FRAGMENT
            }
          }
        }
      }
    }
    payment_methods {
      name
      type
    }
    shipping_address {
      ...ADDRESS_FRAGMENT
    }
    billing_address {
      ...ADDRESS_FRAGMENT
    }
    items {
      ...ORDER_ITEM_FRAGMENT
    }
    total {
      ...ORDER_SUMMARY_FRAGMENT
    }
  }
  ${ADDRESS_FRAGMENT}
  ${APPLIED_GIFT_CARDS_FRAGMENT}
  ${BUNDLE_ORDER_ITEM_DETAILS_FRAGMENT}
  ${GIFT_CARD_DETAILS_FRAGMENT}
  ${GIFT_MESSAGE_FRAGMENT}
  ${GIFT_WRAPPING_FRAGMENT}
  ${ORDER_ITEM_DETAILS_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
  ${ORDER_SUMMARY_FRAGMENT}
  ${PRICE_DETAILS_FRAGMENT}
  ${PRODUCT_DETAILS_FRAGMENT}
  ${RETURNS_FRAGMENT}
`;
